import React, { createElement } from 'react';
import './index.css';
import ReactDOM from 'react-dom/client';
import { App } from './App';
(function initMetaPixel() {
  const PIXEL_ID = '1555763442913803';
  if (typeof window === 'undefined') return;
  /* eslint-disable */
  // @ts-ignore
  !function (f: any, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  // @ts-ignore
  window.fbq('init', PIXEL_ID);
  // @ts-ignore
  window.fbq('track', 'PageView');
  /* eslint-enable */
})();
const rootEl = document.getElementById('root');
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-276" data-mp="1amri6d7ssc5s" />);
}